export const TypesAmount = [
  { label: 'tenant.deductionsTypes.amount', value: 'amount' },
  { label: 'tenant.deductionsTypes.percent', value: 'percent' },
  // { label: 'tenant.deductionsTypes.rangeAmount', value: 'range_amount' },
  { label: 'tenant.deductionsTypes.range_percent', value: 'range_percent' },
];
